import renderComponentFromEl from 'javascripts/utils/renderComponentFromEl';

const elementInBehaviorBasedModal = (el) =>
  $(el)
    .parents()
    .toArray()
    .map((p) => p.id)
    .filter((id) => String(id).trim())
    .find((id) => $(`[href="#${id}"][data-behavior="Modal"]`).length);

document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('[data-component]')).forEach((el) => {
    if (elementInBehaviorBasedModal(el)) return;
    renderComponentFromEl(el);
  });
});
